package org.gymly.data

import org.gymly.model.AdminClient
import org.gymly.model.PickedImagePayload

/**
 * Sube o elimina la foto del socio **sin** sincronizar terminales.
 * Útil en alta masiva: el sync Hikvision se difiere para no bloquear el proceso.
 */
suspend fun AdminRepository.persistClientPhoto(
    clientId: String,
    photo: PickedImagePayload? = null,
    removePhoto: Boolean = false,
): AdminClient {
    if (removePhoto) {
        deleteClientPhoto(clientId)
        return getClient(clientId)
    }
    if (photo != null) {
        return uploadClientPhoto(clientId, photo)
    }
    return getClient(clientId)
}

/**
 * Sube o elimina la foto del socio y sincroniza con terminales Hikvision activos.
 */
suspend fun AdminRepository.persistClientPhotoAndSync(
    clientId: String,
    photo: PickedImagePayload? = null,
    removePhoto: Boolean = false,
): AdminClient {
    val client = persistClientPhoto(clientId, photo = photo, removePhoto = removePhoto)
    runCatching { syncClientAccess(clientId) }
    return runCatching { getClient(clientId) }.getOrDefault(client)
}
